export const processContent = {
  ar: {
    eyebrow: "من أول رسالة إلى التنفيذ",
    title: "بداية بسيطة. وخطوات واضحة.",
    sub: "يكفي أن تعرف ما تريد تحسينه. نحدّد التفاصيل معًا قبل بدء العمل.",
    steps: [
      { title: "أخبرني أين تتعطّل", desc: "صف عملك والمشكلة، أو أرسل رابطًا أو لقطة توضحها. لا تحتاج إلى اختيار التقنية." },
      { title: "نحدّد ما سنبنيه", desc: "نراجع الاحتياج ونتفق على نطاق العمل، وما ستستلمه، والتكلفة والمدة." },
      { title: "تنفيذ وتجربة وتسليم", desc: "نبني الحل المتفق عليه، ونراجع طريقة عمله معك، ثم نسلّمه مع شرح استخدامه." },
    ],
    cta: "أرسل وصفًا لاحتياجك",
  },
  en: {
    eyebrow: "From first message to delivery",
    title: "A simple start. Clear next steps.",
    sub: "You only need to know what you want to improve. We'll work out the details together before starting.",
    steps: [
      { title: "Tell me what's getting in the way", desc: "Describe your work and the problem, or share a link or screenshot. You don't need to choose the technology." },
      { title: "Agree on what we'll build", desc: "We review the need and agree on the scope, deliverables, cost and timing." },
      { title: "Build, review and hand over", desc: "I build the agreed solution, review how it works with you, and hand it over with guidance on using it." },
    ],
    cta: "Tell me what you need",
  },
  fr: {
    eyebrow: "Du premier message à la livraison",
    title: "Un début simple. Des étapes claires.",
    sub: "Il suffit de savoir ce que vous souhaitez améliorer. Nous définissons les détails ensemble avant de commencer.",
    steps: [
      { title: "Décrivez ce qui vous bloque", desc: "Présentez votre activité et le problème, ou partagez un lien ou une capture. Pas besoin de choisir la technologie." },
      { title: "Définissons la solution", desc: "Nous précisons le besoin et convenons du périmètre, des livrables, du coût et du délai." },
      { title: "Réalisation, revue et livraison", desc: "Je réalise la solution convenue, vérifie son fonctionnement avec vous et vous accompagne dans sa prise en main." },
    ],
    cta: "Décrivez votre besoin",
  },
};
